export default function isAppleSiliconByWebGL(): boolean {
  try {
    const canvas = document.createElement("canvas")
    const gl = (canvas.getContext("webgl") || canvas.getContext("experimental-webgl")) as WebGLRenderingContext
    if (!gl) return false

    const debugInfo = gl.getExtension("WEBGL_debug_renderer_info")
    if (!debugInfo) return false

    const renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL) as string
    // Apple Silicon machines report strings like:
    // "Apple M1", "Apple M1 Pro", "Apple M2 Max", etc.
    return /Apple\s*M\d/i.test(renderer)
  } catch {
    return false
  }
}
